module.exports = "# Title - Short\n\nH2WHOA! Follow-up Modules\n\n# Title - Long\n\nH2WHOA! Follow-up Modules\n\n# Description - Short\n\nKeep the fun going in the classroom with two pre-planned modules.\n\n# Description - Long\n\nKeep the fun going in the classroom with two pre-planned modules.\n\n# Description - Levels\n\n**Modules include:**\n&nbsp;\n* Water Wise\n* Celebrate!\n&nbsp;\n\n# Level 1\nTitle: Water Wise\nDescription: How we use water in our daily lives, and how we can save!\n\n# Level 2\nTitle: Celebrate!\nDescription: Report back on the at-home mission and celebrate successes!\n"


//////////////////
// WEBPACK FOOTER
// ./programs/h2whoaHybrid/index.md
// module id = 349
// module chunks = 2